// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hoverTag_wrapper__1WoI0","hoverBox":"hoverTag_hoverBox__3273Q"};